import { ScrollableArea } from '@repo/ui-kit/components/core/ScrollableArea';
import { themeStyle } from '@repo/ui-kit/themeStyle';
import { css, styled } from 'styled-components';

import { FlexColumn, FlexRow } from 'styles/layouts';

interface WorkspacesListProps {
  showBorder?: boolean;
}

export const buttonReset = css`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
`;

export const Selector = styled(FlexRow)`
  padding: ${themeStyle.spacing6} ${themeStyle.spacing10} ${themeStyle.spacing6}
    ${themeStyle.spacing6};
  border-radius: ${themeStyle.borderRadius10};
  max-width: 214px;
  cursor: pointer;
  &:hover {
    background: ${themeStyle.colorBgFillSecondary};
  }

  &.open {
    background: ${themeStyle.colorBgFillTertiary};
  }
`;

export const WorkspaceCurrentItem = styled.div`
  width: 224px;
  padding: ${themeStyle.spacing8};
  border-bottom: 1px solid ${themeStyle.colorBorder};
`;

export const WorkspacesList = styled(ScrollableArea)<WorkspacesListProps>`
  width: 224px;
  max-height: 244px;
  padding: ${themeStyle.spacing8} ${themeStyle.spacing8} 0
    ${themeStyle.spacing8};
  border-bottom: ${(props) =>
    props.showBorder ? `1px solid ${themeStyle.colorBorder}` : 'none'};
`;

export const WorkspaceItem = styled.button`
  ${buttonReset}
  height: 50px;
  display: flex;
  padding: ${themeStyle.spacing8};
  gap: ${themeStyle.spacing8};
  width: 100%;
  &:hover {
    cursor: pointer;
  }
`;

export const SelectableWorkspaceItem = styled(WorkspaceItem)`
  border-radius: ${themeStyle.borderRadius10};
  &:hover {
    background: ${themeStyle.colorBgFillSecondary};
    cursor: pointer;
  }
`;

export const WorkspaceItemDetails = styled(FlexRow)`
  flex: 1;
  justify-content: space-between;
`;

export const WorkspaceItemDetailsName = styled(FlexColumn)`
  gap: ${themeStyle.spacing2};
  text-align: left;
  width: 100px;
`;

export const WorkspaceConfigItem = styled(FlexRow)`
  button {
    width: 200px;
  }
`;

export const WorkspaceSwitchLabel = styled(FlexRow)`
  padding: ${themeStyle.spacing8};
  height: 32px;
`;
